import { Button, Col, Descriptions, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Schedule } from '../../modules/schedules';
import SubScheduleListComponent from './SubScheduleListComponent';
import DependScheduleListComponent from './DependScheduleListComponent';

interface ScheduleDetailComponentProps {
  schedule: Schedule;
  moveToEditPage: (scheduleId: string) => void;
  openSubScheduleCreateModal: () => void;
  onDeleteSubSchedule: (scheduleId: string) => void;
  updateScheduleIndex: (scheduleId: string, scheduleIndex: number) => void;
  openDependAddModal: () => void;
}

function ScheduleDetailComponent({
  schedule,
  moveToEditPage,
  openSubScheduleCreateModal,
  onDeleteSubSchedule,
  updateScheduleIndex,
  openDependAddModal,
}: ScheduleDetailComponentProps) {
  return (
    <>
      <Row justify="space-between">
        <Col>
          <Title level={3}>공정 상세</Title>
        </Col>
        <Col>
          <Button size="small" onClick={() => moveToEditPage('' + schedule.id)}>
            수정
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Descriptions
            // title="청구서"
            bordered
            column={2}
            size="small"
            // style={{ marginTop: '10px' }}
          >
            {/* <Descriptions.Item label="공사종류">
              {schedule.gongjong ? schedule.gongjong : ''}
            </Descriptions.Item> */}
            <Descriptions.Item label="이름">{schedule.name}</Descriptions.Item>
            <Descriptions.Item label="진행률">
              {schedule.complete}%
            </Descriptions.Item>
            <Descriptions.Item label="작성자">
              {schedule.createdBy ? schedule.createdBy.name : ''}
            </Descriptions.Item>
            <Descriptions.Item label="시작일">
              {schedule.startDate}
            </Descriptions.Item>
            <Descriptions.Item label="종료일">
              {schedule.finishDate}
            </Descriptions.Item>
            <Descriptions.Item label="설명" style={{ whiteSpace: 'pre-wrap' }}>
              {schedule.description}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <SubScheduleListComponent
        data={schedule.children}
        openSubScheduleCreateModal={openSubScheduleCreateModal}
        onDeleteSubSchedule={onDeleteSubSchedule}
        updateScheduleIndex={updateScheduleIndex}
      />
      <DependScheduleListComponent
        data={schedule.depends}
        openDependAddModal={openDependAddModal}
      />
    </>
  );
}

export default ScheduleDetailComponent;
